jQuery(document).ready(function($) {
	
	// Mehrere Fallbacks für ACF Ready
	function tryInitialize() {
		if (typeof acf !== 'undefined' && acf.get && acf.get('ready')) {
			initializeCardRows();
			return true;
		}
		return false;
	}
	
	// Sofort versuchen
	if (!tryInitialize()) {
		// ACF Hook versuchen
		if (typeof acf !== 'undefined' && acf.add_action) {
			acf.add_action('ready', function() {
				initializeCardRows();
			});
		}
		
		// Fallback mit setTimeout
		setTimeout(function() {
			if (!tryInitialize()) {
				initializeCardRows();
			}
		}, 1000);
	}
	
	function initializeCardRows() {
		$('.acf-field[data-name="card_repeater"] .acf-row').each(function(){
			updateCardFilterField($(this));
		});
	}
	
	function getParentSettings($cardRow) {
			var $parentBlock = $cardRow.closest('.acf-field[data-name="component_card_grid"]');
			
			// Neue Struktur: Suche in step_1
			var $step1 = $parentBlock.find('.acf-field[data-name="step_1"]');
			var categoryType = '';
			var filterTaxonomy = '';
			var customTerms = [];
			
			if ($step1.length > 0) {
					categoryType = $step1.find('.acf-field[data-name="category_type"] select').val();
					filterTaxonomy = $step1.find('.acf-field[data-name="filter_taxonomy"] select').val();
					
					$step1.find('.acf-field[data-name="custom_terms"] .acf-repeater .acf-row:not(.acf-clone) .acf-field[data-name="term_label"] input').each(function(){
							if ($(this).val()) {
									customTerms.push($(this).val());
							}
					});
			}
			
			console.log('Parent Settings:', {
					category_type: categoryType,
					filter_taxonomy: filterTaxonomy,
					custom_terms: customTerms
			});
			
			return {
					category_type: categoryType,
					filter_taxonomy: filterTaxonomy,
					custom_terms: customTerms
			};
	}

	function updateCardFilterField($cardRow) {
			var settings = getParentSettings($cardRow);
			var $acfFieldEl = $cardRow.find('.acf-field[data-name="card_filter_term_1"]');
			var $checkboxList = $acfFieldEl.find('ul.acf-checkbox-list');
			var acfField = acf.getField($acfFieldEl);

			// Zeige Ladehinweis
			if ($checkboxList.length) {
					$checkboxList.empty().append('<li><span style="color:#888;">Lädt …</span></li>');
			}

			var postId = acf.get('post_id');
			var rowKey = $cardRow.attr('data-id');
			var moduleIndex = $cardRow.closest('.acf-flexible-content .acf-row').index();

			// EIN Request für alles!
			$.post(ajaxurl, {
					action: 'get_card_filter_term_data',
					post_id: postId,
					row_key: rowKey,
					module_index: moduleIndex,
					category_type: settings.category_type,
					filter_taxonomy: settings.filter_taxonomy,
					custom_terms: settings.custom_terms
			}, function(response) {
					if (response.success) {
							var savedValues = Array.isArray(response.data.values) ? response.data.values : [];
							var choices = Array.isArray(response.data.choices) ? response.data.choices : [];
							
							if ($checkboxList.length) {
									$checkboxList.empty();
									if (choices.length === 0) {
											$checkboxList.append('<li><span style="color:#888;">Keine Begriffe gefunden</span></li>');
									} else {
											$.each(choices, function(i, choice){
													var id = 'card_filter_term_' + Math.random().toString(36).substr(2, 9);
													var checked = savedValues.includes(choice.value) ? 'checked' : '';
													var checkboxHtml = '<li>' +
															'<label for="' + id + '">' +
															'<input type="checkbox" id="' + id + '" value="' + choice.value + '" name="' + $checkboxList.closest('.acf-field').find('input[type=\'hidden\']').attr('name') + '[]" ' + checked + '>' +
															choice.label +
															'</label>' +
															'</li>';
													$checkboxList.append(checkboxHtml);
											});

											// Synchronisierung mit ACF
											function syncToACF() {
													var values = [];
													$checkboxList.find('input[type="checkbox"]:checked').each(function() {
															values.push($(this).val());
													});
													if (acfField) {
															acfField.val(values);
													}
											}

											syncToACF();
											$checkboxList.find('input[type="checkbox"]').on('change', function() {
													syncToACF();
											});
									}
							}
					} else {
							console.error('AJAX Response error:', response);
					}
			}).fail(function(xhr, status, error) {
					console.error('AJAX Request failed:', status, error);
					console.error('Response:', xhr.responseText);
			});
	}

	// Event-Listener für Änderungen an den Parent-Feldern
	$(document).on('change', '.acf-field[data-name="step_1"] .acf-field[data-name="category_type"] select, .acf-field[data-name="step_1"] .acf-field[data-name="filter_taxonomy"] select, .acf-field[data-name="step_1"] .acf-field[data-name="custom_terms"] input[type="text"]', function(){
			// Für alle Card-Rows im Grid aktualisieren
			$('.acf-field[data-name="card_repeater"] .acf-row').each(function(){
					updateCardFilterField($(this));
			});
	});
});